import * as React from "react"

import {
    Div,
    Header,
} from "@bdfx/fukit"
import Section from "../homepage/section"

const Conditions = () => {
    document.title = "GDPR | Pricing Audit"

return (<Section>
<div>
    <Div padding="20px 50px" minHeight={"30vh"}>
        <Header type={1}>Informácie o spracovaní osobných údajov</Header>
        <p>
            <ul>
                <li>Aktuálne znenie podmienok upravujúce spracovanie osobných údajov nájdete na <a target="_blank" href={`/pricing/gdpr.pdf`}>tomto odkaze [PDF]</a></li>
            </ul>
        </p>
    </Div>
</div>
</Section>)
}

export default Conditions